import type { Client } from 'typesense';

import { useSearchIndexName, useSearchClient } from '#src/app/pages/search/shared/hooks';

type Result = ModelHookResult<{
	typesenseClient: Client;
	collectionName: string;
	preset: string;
	decisionMakersCollectionName: string;
}>;

export function useLayout(): Result {
	const {
		data: { typesenseClient },
	} = useSearchClient();

	const {
		data: { searchIndexName, searchPreset, decisionMakersIndexName },
	} = useSearchIndexName();

	return {
		data: {
			typesenseClient,
			collectionName: searchIndexName,
			preset: searchPreset,
			decisionMakersCollectionName: decisionMakersIndexName,
		},
	};
}
